<template>
	<div v-if="selectedPlace">
		<div v-if="persons.length">
			<div class="text-center">
				<div class="d-flex inline">
					<v-btn
						v-if="lodgingPerLabel.length && persons.length"
						x-small
						color="primary"
						@click.stop="moveTimeline('left')"
						class="my-2 "
					>
						<v-icon small left>mdi-arrow-left</v-icon>
					</v-btn>

					<v-btn
						v-if="lodgingPerLabel.length && persons.length"
						x-small
						color="primary"
						@click.stop="moveTimeline('right')"
						class=" my-2 "
					>
						<v-icon small right>mdi-arrow-right</v-icon>
					</v-btn>
					<assistant-buttons
						:activities="lodgingPerLabel"
						v-if="itemsPeriods.length && persons.length"
					/>
				</div>

				<span v-if="itemsPeriods.length">
					<template v-for="(item, idPeriod) in itemsPeriods">
						<v-chip
							small
							:key="idPeriod + 'idPeriod1'"
							class="ma-2 white--text"
							:color="item.color"
							@click="selectPeriod(item.period)"
						>
							{{ idPeriod + 1 }}.
							{{ item.period }}
						</v-chip>
					</template>
				</span>
			</div>
			<!-- actividades -->
			<div class="overflow-x-auto">
				<div v-if="!lodgingPerLabel.length && persons.length">
					<data-empty
						:title="`Sin actividades en ${month}.`"
						:msj="`Presione +Actividad para visualizar el cronograma`"
					/>
				</div>
				<div v-if="!lodgingPerLabel.length && !persons.length">
					<data-empty
						title="Sin personas registradas"
						msj="Para ver y crear actividades deben existir personas bajo su gestión"
					/>
				</div>
				<div class="d-flex">
					<div
						v-if="lodgingPerLabel.length && itemsPeriods.length"
						style="min-width:120px"
						class="bb br"
					>
						<div class="text-left body-1">Precios:</div>
						<v-radio-group dense v-model="radioPrices" class="mt-0" hide-details>
							<v-radio
								v-for="item in ['Servicio', 'Actividad']"
								:key="item"
								class="mb-0"
								:label="item"
								:value="item"
							></v-radio>
						</v-radio-group>
					</div>
					<div v-if="persons.length" style="min-width:300px" class="bb br">
						<div class="px-4">
							<v-text-field
								dense
								solo
								outlined
								filled
								small
								class="mt-1"
								label="Mes a visualizar"
								hide-details
								:loading="changeMonth"
								loader-height="4"
								color="info"
								type="month"
								v-model="mes"
							></v-text-field>
							<v-text-field
								solo
								v-if="lodgingPerLabel.length"
								v-model="filterPerson"
								dense
								outlined
								filled
								small
								class="mt-1"
								label="Filtrar persona"
								hide-details
							/>
						</div>
					</div>
					<div
						style="width:1000px"
						v-if="lodgingPerLabel.length && itemsPeriods.length"
						id="rowDates"
						class="text-left bb"
					>
						<div v-scroll:#rowDates="onScrollDate">
							<v-radio-group
								dense
								row
								hide-details
								v-model="toggleIcons"
								class=" text-right d-inline-block mt-0 mb-2"
							>
								<v-radio class="mb-0" :label="'Ver actividades'" :value="'1'" />
								<v-radio class="mb-0" :label="'Ver notificaciones'" :value="'2'" />
								<v-radio class="mb-0" :label="'Ver asistencia'" :value="'3'" />
							</v-radio-group>
							<div class="d-inline-flex">
								<div
									v-for="(date, idRangeDate) in rangeDateTable"
									:key="idRangeDate + 'idRangeDate2'"
									class="itemDateHead"
								>
									{{ date.initialDay }}
								</div>
							</div>
							<div class="d-inline-flex">
								<div
									v-for="(date, idRangeDate) in rangeDateTable"
									:key="idRangeDate + 'idRangeDate3'"
									class="itemDateHead itemInitialDay"
								>
									{{ date.nameDay }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div v-if="lodgingPerLabel.length">
						<div class="d-flex ">
							<div
								v-if="
									lodgingPerLabel.length > 0 &&
										!toggleCost &&
										selectedService.price != '0'
								"
								style="min-width:120px"
								class="br"
							>
								<div v-for="(lod, labelIndex) in lodgingPerLabel" :key="labelIndex">
									<div
										v-if="lod.lodgings.length != 0 && lod.persons.length != 0"
										class="labelMaxWidth my-1 text-right"
									>
										<h4 class="text-right">
											<b>Subtotal</b>
										</h4>
									</div>
									<div
										v-for="(person, personIndex) in lod.persons"
										:key="personIndex"
										class="itemTotal bb text-right"
									>
										<div style="width: 26% !important;">
											({{ person.totalDaysMonth }})
										</div>
										<div>${{ calculatePrice(person, lod) }}</div>
									</div>
								</div>
								<h4>
									<b>Total</b>
								</h4>
								<b v-if="calculateTotal != 'Sin valores'">{{ calculateTotal }}</b>
								<b v-else>{{ calculateTotal }}</b>
							</div>
							<div style="min-width:300px">
								<div
									v-for="(lod, labelIndex) in lodgingPerLabel"
									:key="labelIndex"
									class="br"
								>
									<div
										v-if="lod.lodgings.length != 0 && lod.persons.length != 0"
										class="labelMaxWidth py-1 pl-1"
									>
										<h4 class="text-uppercase">
											{{ lod.label }}
										</h4>
									</div>
									<div
										v-for="(person, personIndex) in lod.persons"
										:key="personIndex"
										class="itemPerson bb pl-1"
										style="height:40px"
									>
										<template v-if="$vuetify.breakpoint.lgAndUp">
											<span>
												<v-icon
													v-if="person.isUser == false"
													small
													color="accent"
												>
													mdi-account-multiple-remove
												</v-icon>
												<v-icon
													v-if="person.isUser == true"
													small
													color="info"
												>
													mdi-account-multiple-check
												</v-icon>
												<v-icon
													v-if="person.isPhoneVerified == 2"
													small
													color="success"
												>
													mdi-cellphone-basic
												</v-icon>
												<v-icon
													v-if="person.isPhoneVerified == 1"
													small
													color="warning
												"
												>
													mdi-cellphone-basic
												</v-icon>
												<v-icon
													v-if="person.isPhoneVerified == 0"
													small
													color="error"
												>
													mdi-cellphone-basic
												</v-icon>

												<v-tooltip
													v-if="getStatusPerson(person) == 'red'"
													left
												>
													<template v-slot:activator="{ onError }">
														<v-icon small color="error" v-on="onError">
															mdi-alert-circle
														</v-icon>
													</template>
													<span>Sin validar</span>
												</v-tooltip>

												<v-tooltip left>
													<template v-slot:activator="{ onSuccess }">
														<v-icon
															v-if="
																getStatusPerson(person) == 'green'
															"
															small
															color="success"
															v-on="onSuccess"
														>
															mdi-alert-circle
														</v-icon>
													</template>
													<span>Verificado</span>
												</v-tooltip>
												<v-tooltip
													v-if="getStatusPerson(person) == 'orange'"
													left
												>
													<template v-slot:activator="{ onWarning }">
														<v-icon
															small
															color="warning"
															v-on="onWarning"
															>mdi-alert-circle</v-icon
														>
													</template>
													<span>Pendiente</span>
												</v-tooltip>
											</span>
										</template>

										<span class="text-capitalize">
											<b>
												{{ person.firstName }}
												{{ person.lastName ? person.lastName : '' }}
											</b>
											<br />
											{{ person.rut ? person.rut : 'Sin RUT' }} •
											{{
												person.appointment
													? person.appointment
													: 'Sin cargo'
											}}
										</span>
									</div>
								</div>
							</div>
							<div id="scroll-target" class="text-left " style="width:1000px">
								<div
									v-for="(lod, labelIndex) in lodgingPerLabel"
									:key="labelIndex"
									v-scroll:#scroll-target="onScroll"
								>
									<div v-if="lod.lodgings.length != 0 && lod.persons.length != 0">
										<div
											v-if="
												lod.lodgings.length != 0 && lod.persons.length != 0
											"
											class="labelMaxWidth my-1 pl-1"
										>
											<h4 class="text-uppercase">
												{{ lod.label }}
											</h4>
										</div>
										<div
											style="height:40px"
											class="bb"
											v-for="(person, personIndex) in lod.persons"
											:key="personIndex"
										>
											<div class="d-inline-flex">
												<div
													v-for="(date, indexDate) in rangeDateTable"
													:key="indexDate + 'indexDate'"
													:class="{
														itemDateHeadBorderDark:
															$vuetify.theme.isDark,
														itemDateHeadBorderLigth: !$vuetify.theme
															.isDark,
														itemEmptyWeekend:
															(date.initialDay == 'sá' ||
																date.initialDay == 'do') &&
															!verifyItemEmptyToday({
																person,
																date,
															}),
														itemEmptyToday: verifyItemEmptyToday({
															person,
															date,
														}),
													}"
													class="itemEmpty"
													@click.capture="
														selectItemEmpty({
															dateAlltimeline: date,
															person: [person._id],
															group: lod.label,
															place: selectedPlace._id,
														});
														reloadLodgingTab();
													"
												>
													<div
														v-for="(lodging,
														lodgingIndex) in lod.lodgings"
														:key="lodgingIndex"
													>
														<div
															v-if="
																lodging.person == person._id &&
																	lodging.group == lod.label &&
																	compareDates({
																		start: lodging.start,
																		end: lodging.end,
																		dayTable: date.numberDay,
																	})
															"
														>
															<details-lodging
																:periodSelected="periodSelected"
																:periods="itemsPeriods"
																:toggleIconsLabel="
																	toggleIcons == '2'
																"
																:toggleIconsAssistance="
																	toggleIcons == '3'
																"
																:lodging="{ ...lodging }"
																:date="date"
																:compareDates="compareDates"
																:editLodging="editLodging"
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ubications class="my-3" v-if="itemsPeriods.length && persons.length" />
		</div>
		<div v-else>
			<v-col cols="12">
				<v-dialog
					v-model="dialogPerson"
					transition="dialog-bottom-transition"
					max-width="800"
				>
					<v-card>
						<v-toolbar color="primary" flat dark>
							Nueva persona
							<v-spacer></v-spacer>
							<v-btn text fab @click="dialogPerson = false">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-toolbar>
						<v-card-text>
							<createPerson :close="() => (dialogPerson = false)" />
						</v-card-text>
					</v-card>
				</v-dialog>
				<data-empty
					title="Sin personas registradas"
					msj="Para ver y crear actividades deben existir personas bajo su gestión"
				/>
			</v-col>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { cloneDeep } from 'lodash';

let moment = extendMoment(Moment);

export default {
	name: 'Activities',
	components: {
		AssistantButtons: () => import('@/components/lodgings/AssistantButtons'),
		Ubications: () => import('@/components/lodgings/Ubications'),
		DataEmpty: () => import('@/components/ui/DataEmpty'),
		DetailsLodging: () => import('@/components/lodgings/DetailsLodging'),
	},
	data() {
		return {
			changeMonth: false,
			lodgingTab: true,
			radioPrices: 'Servicio',
			moveTimelineNumber: 0,
			dialogPerson: false,
			expandHelp: false,
			toggleCost: false,
			toggleIcons: '1',
			containerDates: null,
			filterPerson: '',
			itemsPeriods: [],
			periodSelected: '',
			sortLabel: [],
			colors: [
				'red',
				'blue',
				'green',
				'indigo',
				'purple',
				'teal',
				'orange',
				'brown',
				'deep-orange',
				'blue-grey',
				'cyan',
			],
		};
	},
	computed: {
		lodgingPerLabel() {
			let lodgingFilterLabel = [];
			if (this.persons.length)
				this.labelAvalaibles.forEach(label => {
					let filterLodging = this.filterLodgings.filter(l => {
						return l.group == label.text;
					});
					if (filterLodging.length > 0)
						lodgingFilterLabel.push({
							lodgings: filterLodging,
							label: label.text,
							sortNumber: label.sortNumber,
						});
				});
			lodgingFilterLabel.forEach(lf => {
				let personsFilterLabel = [];
				const searchList = this.filterPerson
					.trim()
					.toLowerCase()
					.split(' ');
				lf.lodgings.forEach(l => {
					if (
						!personsFilterLabel.find(pl => {
							if (pl) return pl._id == l.person;
						})
					) {
						let personOfPersons = cloneDeep(this.persons.find(p => p._id == l.person));
						if (personOfPersons === undefined) return;
						if (this.personsFind(personOfPersons, searchList))
							personsFilterLabel.push(personOfPersons);
					}
				});
				lf.persons = personsFilterLabel;
			});
			lodgingFilterLabel.forEach(lpl => {
				if (lpl.persons)
					lpl.persons.forEach(p => {
						let totalDaysLodgings = 0;
						lpl.lodgings.forEach(l => {
							if (l.person == p._id) {
								//Si parte antes y termina dentro
								if (
									moment(l.start).isBefore(moment(this.rangeDate.start)) &&
									moment(l.end).isSameOrAfter(moment(this.rangeDate.start))
								)
									totalDaysLodgings +=
										moment(l.end).diff(this.rangeDate.start, 'days') + 1;

								//Si parte dentro y termina dsp

								if (
									moment(l.end).isAfter(moment(this.rangeDate.end)) &&
									moment(l.start).isSameOrBefore(moment(this.rangeDate.end))
								)
									totalDaysLodgings +=
										this.rangeDate.end.diff(l.start, 'days') + 1;
								//Dentro

								if (
									moment(l.start).isSameOrAfter(moment(this.rangeDate.start)) &&
									moment(l.end).isSameOrBefore(moment(this.rangeDate.end))
								)
									totalDaysLodgings += moment(l.end).diff(l.start, 'days') + 1;
							}
						});
						p.totalDaysMonth = totalDaysLodgings;
					});
			});
			return lodgingFilterLabel;
		},
		labelAvalaibles() {
			let labelNames = [];
			if (!labelNames.some(group => group.value == 'Sin periodo'))
				labelNames.push({
					value: 'Sin periodo',
					text: 'Sin periodo',
					sortNumber: -1,
				});
			let newIndex = 0;
			this.filterLodgings.forEach(lod => {
				if (lod.group)
					if (!labelNames.some(group => group.value == lod.group)) {
						labelNames.push({
							value: lod.group,
							text: lod.group,
							sortNumber: newIndex,
						});
						newIndex++;
					}
			});
			labelNames.forEach(ln => {
				if (this.sortLabel.length > 0) {
					let sls = this.sortLabel.find(sl => sl.name == ln.text);
					if (sls) ln.sortNumber = sls.count;
				}
			});
			labelNames = labelNames.sort((a, b) => {
				if (a.text > b.text) return 1;
				if (a.text < b.text) return -1;
				return 0;
			});

			return labelNames;
		},
		calculateTotal() {
			let total = 0;
			let total2 = 0;
			if (this.radioPrices == 'Actividad') {
				this.lodgingPerLabel.forEach(lpl => {
					lpl.persons.forEach(person => {
						lpl.lodgings.forEach(lod => {
							if (person._id == lod.person && lod.price) total += lod.price;
						});
					});
				});
				if (total) return total;
				else return 0;
			}
			if (this.radioPrices == 'Servicio') {
				this.lodgingPerLabel.forEach(lpl => {
					lpl.persons.forEach(
						person => (total2 += person.totalDaysMonth * lpl.lodgings[0].service.price)
					);
				});
				return total2;
			}
			return 0;
		},
		filterLodgings() {
			if (this.selectedService && this.selectedPlace) {
				if (this.periodSelected)
					return this.lodgings.filter(
						lod =>
							((moment(lod.start).isBefore(moment(this.rangeDate.start)) &&
								moment(lod.end).isSameOrAfter(moment(this.rangeDate.start))) ||
								(moment(lod.end).isAfter(moment(this.rangeDate.end)) &&
									moment(lod.start).isSameOrBefore(moment(this.rangeDate.end))) ||
								(moment(lod.start).isSameOrAfter(moment(this.rangeDate.start)) &&
									moment(lod.end).isSameOrBefore(moment(this.rangeDate.end)))) &&
							lod.room === this.periodSelected &&
							lod.service._id === this.selectedService._id
					);
				else
					return this.lodgings.filter(
						lod =>
							((moment(lod.start).isBefore(moment(this.rangeDate.start)) &&
								moment(lod.end).isSameOrAfter(moment(this.rangeDate.start))) ||
								(moment(lod.end).isAfter(moment(this.rangeDate.end)) &&
									moment(lod.start).isSameOrBefore(moment(this.rangeDate.end))) ||
								(moment(lod.start).isSameOrAfter(moment(this.rangeDate.start)) &&
									moment(lod.end).isSameOrBefore(moment(this.rangeDate.end)))) &&
							lod.service._id === this.selectedService._id
					);
			}
			return [];
		},
		rangeDateTable() {
			let dates = [];
			let numberDays = this.rangeDate.end.diff(this.rangeDate.start, 'days');
			for (let i = 0; i <= numberDays; i++)
				dates.push({
					numberDay: moment(this.rangeDate.start)
						.add(i, 'day')
						.format('YYYY-MM-DD'),
					nameDay: moment(this.rangeDate.start)
						.add(i, 'day')
						.format('DD'),
					initialDay: moment(this.rangeDate.start)
						.add(i, 'day')
						.format('dd'),
					dateMoment: moment(this.rangeDate.start).add(i, 'day'),
				});

			return dates;
		},
		mes: {
			get: function() {
				return this.month;
			},
			set: function(newValue) {
				this.setMonth(newValue);
			},
		},
		...mapGetters({
			itemEmpty: 'Lodging/itemEmpty',
			loadingLodgings: 'Lodging/loadingLodgings',
			lodgings: 'Lodging/lodgings',
			lodgingSelect: 'Lodging/lodgingSelect',
			lodgingWithProblems: 'Lodging/lodgingWithProblems',
			persons: 'Person/persons',
			rangeDate: 'Lodging/rangeDate',
			selectedPlace: 'Lodging/selectedPlace',
			selectedService: 'Lodging/selectedService',
			month: 'Lodging/month',
		}),
	},
	watch: {
		async month(newVal) {
			this.changeMonth = true;
			await this.fetchLodgings(this.selectedPlace._id);
			this.setRangeDate({
				start: moment(newVal).date(1),
				end: moment(newVal)
					.clone()
					.endOf('month'),
			});
			this.changeMonth = false;
		},
		filterLodgings() {
			this.setItemsPeriods();
		},
	},
	mounted() {
		this.setRangeDate({
			start: moment().date(1),
			end: moment()
				.clone()
				.endOf('month'),
		});
		this.setItemsPeriods();
	},
	methods: {
		reloadLodgingTab() {
			this.lodgingTab = false;
			setTimeout(() => (this.lodgingTab = true), 10);
		},
		calculatePrice(person, lod) {
			let amount = 0;
			if (this.radioPrices == 'Actividad') {
				lod.lodgings.forEach(lod => {
					if (person._id == lod.person && lod.price) amount += lod.price;
				});
				if (amount) return amount;
				else return 0;
			}
			if (this.radioPrices == 'Servicio')
				return person.totalDaysMonth * this.selectedService.price;
		},
		moveTimeline(dir) {
			if (dir == 'left' && this.moveTimelineNumber >= 50)
				this.moveTimelineNumber = this.moveTimelineNumber - 50;

			if (
				dir == 'right' &&
				this.moveTimelineNumber < 650 &&
				!this.$vuetify.breakpoint.lgAndUp
			)
				this.moveTimelineNumber = this.moveTimelineNumber + 50;
			if (dir == 'right' && this.moveTimelineNumber < 250 && this.$vuetify.breakpoint.lgAndUp)
				this.moveTimelineNumber = this.moveTimelineNumber + 50;
			this.containerDates = this.$el.querySelector('#rowDates');
			this.containerDates.scrollLeft = this.moveTimelineNumber;
			this.containerDates = this.$el.querySelector('#scroll-target');
			this.containerDates.scrollLeft = this.moveTimelineNumber;
		},
		setItemsPeriods() {
			this.itemsPeriods = [];
			this.filterLodgings.forEach(item => {
				if (item.room && !this.itemsPeriods.some(el => el.period == item.room))
					this.itemsPeriods.push({ period: item.room });
				// Establece el color de los periodos
				// El counter maximo debe ser hasta numero de colores en this.colors
				let counter = 0;
				this.itemsPeriods = this.itemsPeriods.map(el => {
					const element = { period: el.period, color: this.colors[counter] };
					counter == 10 ? (counter = 0) : counter++;
					return element;
				});
			});
		},
		onScroll(e) {
			this.containerDates = this.$el.querySelector('#rowDates');
			this.containerDates.scrollLeft = e.target.scrollLeft;
		},
		onScrollDate(e) {
			this.containerDates = this.$el.querySelector('#scroll-target');
			this.containerDates.scrollLeft = e.target.scrollLeft;
		},
		personsFind(person, searchList) {
			let itemText = person.firstName + person.lastName + person.rut;
			itemText = itemText.toLowerCase();
			let count = 0;
			searchList.forEach(b => {
				if (itemText.indexOf(b) > -1) count++;
			});
			return searchList.length === count;
		},
		moveLabel(dir, index, name) {
			if (!this.sortLabel.some(s => s.name == name)) this.sortLabel.push({ name });
			this.sortLabel = this.sortLabel.map(item => {
				if (dir == 'up' && item.name == name)
					item.count
						? item.count >= 0
							? (item.count -= 1)
							: null
						: (item.count = index - 1);
				if (dir == 'down' && item.name == name)
					item.count ? (item.count += 1) : (item.count = index + 1);
				return {
					name: item.name,
					count: item.count,
				};
			});
		},
		getStatusPerson(person) {
			if (!person.documents.length && person.typeDocument.length) {
				return 'red';
			} else {
				if (person.typeDocument.some(doc => doc !== null && doc.done === false))
					return 'orange';
				else return 'green';
			}
		},
		verifyItemEmptyToday(payload) {
			const today = moment().format('YYYY-MM-DD');
			if (this.itemEmpty) {
				return (
					(payload.person._id == this.itemEmpty.person._id &&
						payload.date.numberDay == this.itemEmpty.date.numberDay) ||
					moment(today).isSame(moment(payload.date.numberDay))
				);
			} else {
				if (moment(today).isSame(moment(payload.date.numberDay))) return true;
				else return false;
			}
		},
		selectPeriod(period) {
			this.periodSelected = this.periodSelected ? '' : period;
		},
		editLodging(lodging) {
			if (this.lodgingSelect == lodging || lodging == 'close') {
				this.setModeEdit(false);
				this.setLodgingSelect(null);
				this.selectItemEmpty(null);
				this.reloadLodgingTab();
				setTimeout(() => {
					//DEJARA ACTIVO EL COLOR ROJO EN EL ITEM PARA Q EL USER LO VEA
					this.setLodgingWithProblems(null);
				}, 8000);
			} else {
				this.setModeEdit(true);
				this.setLodgingSelect(lodging);
				this.setLodgingWithProblems(null);
				this.reloadLodgingTab();
			}
		},
		compareDates(payload) {
			if (payload.text) {
				return (
					(moment(payload.start).month() !==
						moment(this.rangeDateTable[0].numberDay).month() &&
						moment(payload.dayTable).isSame(
							moment(this.rangeDateTable[0].numberDay)
						)) ||
					moment(payload.dayTable).isSame(moment(payload.start))
				);
			} else {
				return (
					moment(payload.dayTable).isSameOrAfter(moment(payload.start)) &&
					moment(payload.dayTable).isSameOrBefore(moment(payload.end))
				);
			}
		},
		...mapActions({ fetchLodgings: 'Lodging/fetchLodgings' }),
		...mapMutations({
			selectItemEmpty: 'Lodging/selectItemEmpty',
			setLodgingWithProblems: 'Lodging/setLodgingWithProblems',
			setModeEdit: 'Lodging/setModeEdit',
			setRangeDate: 'Lodging/setRangeDate',
			setLodgingSelect: 'Lodging/setLodgingSelect',
			setMonth: 'Lodging/setMonth',
		}),
	},
};
</script>

<style lang="scss" scoped>
.maxHeightTimeline {
	max-height: 400px;
	overflow-y: auto;
	margin-bottom: 20px;
}

.v-icon {
	position: static !important;
}
.labelMaxWidth {
	width: max-content;
}
.itemEmpty:hover {
	background-color: #80808040 !important;
}
.itemEmptyToday {
	background-color: #6a31ff61 !important;
}
.itemEmptyWeekend {
	background-color: #80808059 !important;
}
.itemTotal div {
	display: inline-block;
	width: 60%;
	height: 40px;
}
.itemNamePeriodSelect {
	border: 2px solid #ad1f98 !important;
	border-radius: 25px;
}
.itemInitialDay {
	border-left: 1px solid white;
	border-right: 1px solid white;
}
.itemTotal {
	height: 40px;
	max-width: 150px;
	background-color: white;
	text-align: left;
	display: flex;
	background-color: transparent;
	font-size: 12px;
}
.itemPerson {
	background-color: white;
	text-align: left;
	font-size: 12px;
	background-color: transparent;
}
.nameMonth {
	width: 300px;
	text-align: left;
}
.itemEmpty {
	height: 40px !important;
	max-height: 40px !important;
	width: 30px;
	background-color: #477a8621;
}
.itemDateHeadBorderDark {
	border-right: 1px solid black;
}
.itemDateHeadBorderLigth {
	border-right: 1px solid white;
}
.itemDateHead {
	width: 30px;
	height: 20px;
	align-items: center;
	text-align: center;
	border-right: 1px solid #477a8621;
	border-left: 0px;
}
.bb-place {
	border-bottom: 1px solid black;
}
.bb {
	border-bottom: 1px solid rgb(159, 159, 159);
}
.br {
	border-right: 1px solid rgb(159, 159, 159);
}
.bt {
	border-top: 1px solid rgb(159, 159, 159);
}
.bl {
	border-left: 1px solid rgb(159, 159, 159);
}
</style>
